import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import '@progress/kendo-angular-intl/locales/ro/all';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { AdminUsersListComponent } from './admin-users-list/admin-users.list.component';
import { AdminUsersRoutingModule } from './admin-users-routing.module';
import { AdminUsersListFilterComponent } from './admin-users-list/admin-users-list-filter/admin-users-list-filter.component';
import { AdminUserListViewComponent } from './admin-users-list/admin-user-list-view/admin-user-list-view.component';
import { AdminUserCardViewComponent } from './admin-users-list/admin-user-card-view/admin-user-card-view.component';
import { AdminUserDetailComponent } from './admin-user-detail/admin-user-detail.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AdminUserPermissionConfiguratorComponent } from '../admin-user-permission-configurator/admin-user-permission-configurator.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    AdminUsersRoutingModule,
    ComponentsModule,
    DateInputsModule,
    FormsModule,
    PipeModule,
    DropDownsModule,
    InputsModule,
    NgbModule,
  ],
  declarations: [
    AdminUsersListComponent,
    AdminUsersListFilterComponent,
    AdminUserListViewComponent,
    AdminUserCardViewComponent,
    AdminUserDetailComponent,
    AdminUserPermissionConfiguratorComponent,
  ],
})
export class AdminUsersModule {}
